import React from "react";
import { Helmet } from "react-helmet";
import {
  Headline,
  Paragraph,
  Section,
  ContentBlock,
  InlineLink,
} from "../components/ui";

const Impressum = () => {
  return (
    <>
      <Helmet>
        <title>Impressum | WTM Sportwagen</title>
        <meta
          name="description"
          content="Impressum und rechtliche Hinweise der WTM Sportwagen Werkstatt in Gießen."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Section variant="primary" spacing="spacious" margin={false}>
        <ContentBlock maxWidth="4xl" className="mx-auto">
          <Headline variant="h1" color="secondary" className="text-left mb-12">
            Impressum
          </Headline>

          {/* Company Information */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-4">
              WTM Sportwagen Werkstatt
            </Headline>
            <Paragraph
              variant="base"
              color="secondary"
              className="text-left mb-2"
            >
              Grünberger Str. 140
              <br />
              35394 Gießen
              <br />
              Steuernummer: ZO 88Z 60764
              <br />
              USt-IdNr.: DE369608082
            </Paragraph>
          </div>

          {/* Representative */}
          <div className="mb-12">
            <Headline variant="h4" color="secondary" className="text-left mb-4">
              Vertreten durch:
            </Headline>
            <Paragraph variant="base" color="secondary" className="text-left">
              Andreas Wutschke
            </Paragraph>
          </div>

          {/* Contact */}
          <div className="mb-12">
            <Headline variant="h4" color="secondary" className="text-left mb-4">
              Kontakt:
            </Headline>
            <Paragraph variant="base" color="secondary" className="text-left">
              Telefon: 01793434888
              <br />
              E-Mail: werkstatt@wtm-sportwagen.com
              <br />
              Website: https://www.wtm-sportwagen.com
            </Paragraph>
          </div>

          {/* Legal Disclaimers */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-8">
              Disclaimer – rechtliche Hinweise
            </Headline>

            {/* Section 1 */}
            <div className="mb-8">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                § 1 Warnhinweis zu Inhalten
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Die kostenlosen und frei zugänglichen Inhalte dieser Webseite
                wurden mit größtmöglicher Sorgfalt erstellt. Der Anbieter dieser
                Webseite übernimmt jedoch keine Gewähr für die Richtigkeit und
                Aktualität der bereitgestellten kostenlosen und frei
                zugänglichen journalistischen Ratgeber und Nachrichten.
                Namentlich gekennzeichnete Beiträge geben die Meinung des
                jeweiligen Autors und nicht immer die Meinung des Anbieters
                wieder. Allein durch den Aufruf der kostenlosen und frei
                zugänglichen Inhalte kommt keinerlei Vertragsverhältnis zwischen
                dem Nutzer und dem Anbieter zustande, insoweit fehlt es am
                Rechtsbindungswillen des Anbieters.
              </Paragraph>
            </div>

            {/* Section 2 */}
            <div className="mb-8">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                § 2 Externe Links
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Diese Website enthält Verknüpfungen zu Websites Dritter
                („externe Links"). Diese Websites unterliegen der Haftung der
                jeweiligen Betreiber. Der Anbieter hat bei der erstmaligen
                Verknüpfung der externen Links die fremden Inhalte daraufhin
                überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem Zeitpunkt
                waren keine Rechtsverstöße ersichtlich. Der Anbieter hat
                keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung
                und auf die Inhalte der verknüpften Seiten. Das Setzen von
                externen Links bedeutet nicht, dass sich der Anbieter die hinter
                dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine
                ständige Kontrolle der externen Links ist für den Anbieter ohne
                konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei
                Kenntnis von Rechtsverstößen werden jedoch derartige externe
                Links unverzüglich gelöscht.
              </Paragraph>
            </div>

            {/* Section 3 */}
            <div className="mb-8">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                § 3 Urheber- und Leistungsschutzrechte
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Die auf dieser Website veröffentlichten Inhalte unterliegen dem
                deutschen Urheber- und Leistungsschutzrecht. Jede vom deutschen
                Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung
                bedarf der vorherigen schriftlichen Zustimmung des Anbieters
                oder jeweiligen Rechteinhabers. Dies gilt insbesondere für
                Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung,
                Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder
                anderen elektronischen Medien und Systemen. Inhalte und Rechte
                Dritter sind dabei als solche gekennzeichnet. Die unerlaubte
                Vervielfältigung oder Weitergabe einzelner Inhalte oder
                kompletter Seiten ist nicht gestattet und strafbar. Lediglich
                die Herstellung von Kopien und Downloads für den persönlichen,
                privaten und nicht kommerziellen Gebrauch ist erlaubt.
              </Paragraph>
              <Paragraph
                variant="base"
                color="secondary"
                className="text-left mt-4"
              >
                Die Darstellung dieser Website in fremden Frames ist nur mit
                schriftlicher Erlaubnis zulässig.
              </Paragraph>
            </div>

            {/* Section 4 */}
            <div className="mb-8">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                § 4 Besondere Nutzungsbedingungen
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Soweit besondere Bedingungen für einzelne Nutzungen dieser
                Website von den vorgenannten Paragraphen abweichen, wird an
                entsprechender Stelle ausdrücklich darauf hingewiesen. In diesem
                Falle gelten im jeweiligen Einzelfall die besonderen
                Nutzungsbedingungen.
              </Paragraph>
              <Paragraph
                variant="small"
                color="secondary"
                className="text-left mt-4 italic"
              >
                Quelle: Impressum Vorlage von JuraForum.de
              </Paragraph>
            </div>
          </div>

          {/* Consumer Dispute Resolution */}
          <div className="mb-12">
            <Headline variant="h3" color="secondary" className="text-left mb-6">
              Verbraucherstreitbeilegung
            </Headline>

            <div className="mb-6">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                Hinweis gemäß § 36 Verbraucher-Streitbeilegungs-Gesetz (VSBG)
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Der Verkäufer/Auftragnehmer wird nicht an einem
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle im Sinne des VSBG teilnehmen und
                ist hierzu auch nicht verpflichtet.
              </Paragraph>
            </div>

            <div className="mb-6">
              <Headline
                variant="h4"
                color="secondary"
                className="text-left mb-4"
              >
                EU-Streitbeilegung
              </Headline>
              <Paragraph variant="base" color="secondary" className="text-left">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung bereit, die Sie unter{" "}
                <InlineLink href="https://ec.europa.eu/consumers/odr/" external>
                  ec.europa.eu/consumers/odr/
                </InlineLink>{" "}
                finden.
              </Paragraph>
              <Paragraph
                variant="base"
                color="secondary"
                className="text-left mt-4"
              >
                Wir ziehen es vor, Ihre Anliegen im direkten Austausch mit Ihnen
                zu klären und nehmen daher nicht an
                Verbraucherschlichtungsverfahren teil. Bitte kontaktieren Sie
                uns bei Fragen und Problemen direkt.
              </Paragraph>
            </div>
          </div>

          {/* Trademark Notice */}
          <div className="mb-12">
            <Headline variant="h4" color="secondary" className="text-left mb-4">
              Markenhinweis
            </Headline>
            <Paragraph variant="base" color="secondary" className="text-left">
              Wir weisen darauf hin, dass "Porsche" eine eingetragene Marke der
              Firma Dr.-Ing.h.c.F. Porsche ist. Wir sind mit der Dr. Ing. h.c.
              F. Porsche AG in keiner Form verbunden.
            </Paragraph>
          </div>

          {/* Image Sources */}
          <div className="mb-8">
            <Headline variant="h4" color="secondary" className="text-left mb-4">
              Bildquellen:
            </Headline>
            <Paragraph variant="base" color="secondary" className="text-left">
              WTM Sportwagen Werkstatt
            </Paragraph>
          </div>
        </ContentBlock>
      </Section>
    </>
  );
};

export default Impressum;
